import { useEffect, useState } from "react";
import { Button, Checkbox, Form, Modal } from "semantic-ui-react";
import ErrorsView from "./ErrorsView";

export interface FormData {
  max: number;
  hasLimit: boolean;
}

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (max: number | null) => void;
  submitInProgress: boolean;
  currentMax?: number | null;
  errors?: string[];
}

const SetMaxProjectAssignmentsModal = ({ open, onClose, onSubmit, submitInProgress, currentMax, errors }: Props) => {
  const [formData, setFormData] = useState<FormData>({} as FormData);

  useEffect(() => {
    if (open) {
      setFormData({
        max: currentMax ?? 0,
        hasLimit: currentMax !== null && currentMax !== undefined,
      } as FormData);
    } else {
      setFormData({} as FormData);
    }
  }, [open, currentMax]);

  const handleChange = (e: any, { name, value }: any) => {
    setFormData({ ...formData, [name]: parseInt(value, 10) || 0 });
  };

  const handleCheckboxChange = (e: any, { checked }: any) => {
    setFormData({ ...formData, hasLimit: checked ?? false });
  };

  const handleSubmit = () => {
    onSubmit(formData.hasLimit ? formData.max : null);
  };

  return (
    <Modal open={open} size="mini">
      <Modal.Header>Set Maximum Project Assignments</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form>
            <Form.Field>
              <Checkbox label="Set maximum limit" checked={formData.hasLimit} onChange={handleCheckboxChange} />
            </Form.Field>
            <Form.Group widths="equal">
              <Form.Input
                type="number"
                value={formData.max}
                label="Maximum Assignments"
                name="max"
                onChange={handleChange}
                min="0"
                disabled={!formData.hasLimit}
              />
            </Form.Group>
          </Form>
          {errors && <ErrorsView errors={errors} />}
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} disabled={submitInProgress}>
          Cancel
        </Button>
        <Button color="green" onClick={handleSubmit} loading={submitInProgress}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default SetMaxProjectAssignmentsModal;
